import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit, OnChanges {
  @Output()
  pageEmitter: EventEmitter<number>;

  @Input() // current page
  currentPage: number;
  @Input() // count of items
  count: number;
  @Input() // limit per page
  limit: number;
  @Input() // max range of page from the current one
  range = 2;

  public pageNumber: number; // Number of page
  public pages: number[]; // Array of displayed pages
  public before: Array<number>; // Pages before the currentPage
  public after: Array<number>; // Pages after the currentPage

  constructor() {
    this.pageEmitter = new EventEmitter<number>();
  }

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.pageNumber = Math.ceil(this.count / this.limit);
    // Create array of needed length
    const length = this.range * 2 + 1;
    this.pages = [...Array(length)];

    // Set pages values arround the current page
    for (let i = 0; i < length; i++) {
      this.pages[i] = this.currentPage - (this.range - i);
    }

    // Remove pages outside boundaries
    this.pages = this.pages.filter(page => page > 0 && page <= this.pageNumber);
  }

  onPageClick(page: number): void {
    this.pageEmitter.emit(page);
  }
}
